
export enum Ops {
    GETREFERRAL=1,
    CREATEREFERRAL=2,
    GENERATEREPORT=3,
    GETREFERRALTYPES= 4,
    ADDREFERRERS=5,
    GETREPORT=6,
    STARTPROCESS=7,
    ORGGETREFERRERNETWORK=7,
    ORGSENDENTITYREMINDER=8,
    ENTITYREMINDREFERRERS=8,
    CREATEENTITYREFERRAL="createEntityReferral",
    CREATEEMPREFERRAL="createEmpReferral",
}
